module.exports = __webpack_public_path__ + "static/media/items.7a9493eb.svg";